import { Controller, MainMenu, Menu, Toolbar } from '@tencent/workbench';
import { ChangeBgFeature } from './change-bg-feature';
import { INSERT_TEXT_MENU_CONFIGS, config, TOOLBAR_ITEMS, toolbarConfig } from './config';
import * as React from 'react';

@Controller({
    menuItems: INSERT_TEXT_MENU_CONFIGS,
    toolbarItems: TOOLBAR_ITEMS,
})
export class ChangeBgController {
    constructor(private readonly feature: ChangeBgFeature) {
    }

    @Menu(config.id, 'onClick')
    @Toolbar(toolbarConfig.id, 'onClick', { reportConfig: toolbarConfig })
    public onClick(arg: { reportConfig?: any }) {
        const rightSideBarManager = this.feature.getAppService().editableServiceLayer?.rightSideBarManager;
        if (rightSideBarManager?.isPropertyEditorShown) {
            rightSideBarManager.setIsPropertyEditorShown(false);
            return;
        }
        this.feature.callback();
        if (arg?.reportConfig) {
            this.feature.twdReport(undefined, undefined, arg.reportConfig);
        }
    }

    @Toolbar(toolbarConfig.id, 'shouldCheck')
    public shouldCheck() {
        return !!this.feature.getAppService().editableServiceLayer?.rightSideBarManager?.isPropertyEditorShown;
    }
}
